const r={TEXT:"text",EMAIL:"email",NUMBER:"number",PASSWORD:"password",URL:"url",CURRENCY:"currency"};export{r as TYPES};
